import { render, staticRenderFns } from "./RoleFormDialog.vue?vue&type=template&id=155e59bc"
import script from "./RoleFormDialog.vue?vue&type=script&lang=js"
export * from "./RoleFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports